import React from 'react';

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <p className="footer-tagline">"Command your beauty. Glaminant makes it effortless."</p>
        <p>© 2026 Glaminant. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;